import React from 'react'

let url              				 = process.env.PUBLIC_URL;
let redirect_url             = 'https://coffeeshophotel.com/hotel-reservation'
let route 									 = '/hotel-reservation/'

export function RouteURL(props) {
	return route+props;
}

export function WindowReload(props){
   return window.location.reload();
}

export function WindowURL(props) {
	return url+props;
}


export function RedirectURL(props) {
	return redirect_url+props;
}


export function WindowLocation(props) {
	return window.location.href = url+props;
}

export function ActiveMenu(props){
   let path = window.location.pathname;
   var url=path.split('/');
   const found = url.find(element => element === props);
   if(found==props){
     return true;
   }else{
     return false;
   }
}
